import { CommonModule } from '@angular/common';
import { ContentStoreEffects } from './content.effects';
import { EffectsModule } from '@ngrx/effects';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { contentReducer } from './content.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('content-editor', contentReducer),
    EffectsModule.forFeature([ContentStoreEffects]),
  ],
  providers: [ContentStoreEffects],
})
export class ContentStoreModule {}
